import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../environments/environment';
import { LocaleService } from './locale/locale.service';
import { AppService } from './app.service';


@Injectable()
export class ApiInterceptor implements HttpInterceptor {

  constructor(private app: AppService, private locale: LocaleService) {
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (request.url.includes('https:') && request.url.includes('s3')) {
      return next.handle(request);
    }

    let url: string;

    // weak checking (need to find better way)
    if (request.url.includes(environment.phpApiVersion)) {
      url = environment.phpApiUrl + request.url;
    } else if (
      request.url.includes(environment.javaApiVersion)
      || request.url.includes(environment.javaAccountingApiVersion)
      || request.url.includes(environment.javaEcommerceApiVersion)
    ) {
      url = environment.javaApiUrl + request.url;
    } else {
      url = environment.apiUrl + request.url;
    }

    if (!request.url.includes('i18n')) {
      const headers: any = {
        Accept: 'application/json',
      };

      if (
        !request.url.includes(environment.javaApiVersion)
        && !request.url.includes(environment.javaAccountingApiVersion)
        && !request.url.includes(environment.phpApiVersion)
        && !request.url.includes(environment.javaEcommerceApiVersion)
      ) {
        headers['language'] = this.app.currentLangIso;
        headers['localization'] = this.locale.appLocale || 'global';
      }


      request = request.clone({
        url,
        setHeaders: headers,
      });
    }

    return next.handle(request);
  }
}
